import * as React from 'react'

import { createContext } from '~logic/lib/react'

type TContextValue = {
  areCustomerAccountsEnabled: boolean
}

const [
  Provider, //
  useCustomerAccountsEnabledCtx,
] = createContext<TContextValue>(`CustomerAccountsEnabled`)

type TProps = RequiredChildren & {
  areCustomerAccountsEnabled: boolean
}

/**
 * Provides the `areCustomerAccountsEnabled` flag,
 * that is used to determine whether the customer accounts features should be displayed or not.
 *
 * ! Customer accounts are disabled/enabled for the brand - it is a brand setting.
 * Therefore we can use the global provider like this and read the value from any branch (firstOrOnlyBranch helper).
 * If this is about to change in the future, we will have to determine the selected/order branch and get the setting from its data.
 */
export const BaseCustomerAccountsEnabledProvider: React.FC<TProps> = ({
  areCustomerAccountsEnabled,
  children,
}) => {
  return <Provider value={{ areCustomerAccountsEnabled }}>{children}</Provider>
}

export { useCustomerAccountsEnabledCtx }
